/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalibrationItem } from './CalibrationItem';
import {
    CalibrationItemFromJSON,
    CalibrationItemFromJSONTyped,
    CalibrationItemToJSON,
    CalibrationItemToJSONTyped,
} from './CalibrationItem';

/**
 * 
 * @export
 * @interface Calibration
 */
export interface Calibration {
    [key: string]: any | any;
    /**
     * 
     */
    calibrations: Array<CalibrationItem>;
    /**
     * 
     */
    tare?: number | null;
    /**
     * 
     */
    calibrationType?: CalibrationCalibrationTypeEnum | null;
    /**
     * 
     */
    calibrationCompletedAt?: string | null;
    /**
     * 
     */
    lastTaredAt?: string | null;
    /**
     * 
     */
    expectedFractions?: { [key: string]: number; } | null;
    /**
     * 
     */
    signs?: { [key: string]: number; } | null;
}


/**
 * @export
 */
export const CalibrationCalibrationTypeEnum = {
    Global: 'global',
    PerCell: 'per_cell',
} as const;
export type CalibrationCalibrationTypeEnum = typeof CalibrationCalibrationTypeEnum[keyof typeof CalibrationCalibrationTypeEnum];


/**
 * Check if a given object implements the Calibration interface.
 */
export function instanceOfCalibration(value: object): value is Calibration {
    if (!('calibrations' in value) || value['calibrations'] === undefined) return false;
    return true;
}

export function CalibrationFromJSON(json: any): Calibration {
    return CalibrationFromJSONTyped(json, false);
}

export function CalibrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Calibration {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'calibrations': ((json['calibrations'] as Array<any>).map(CalibrationItemFromJSON)),
        'tare': json['tare'] === undefined ? undefined : json['tare'] === null ? null : json['tare'],
        'calibrationType': json['calibration_type'] === undefined ? undefined : json['calibration_type'] === null ? null : json['calibration_type'],
        'calibrationCompletedAt': json['calibration_completed_at'] === undefined ? undefined : json['calibration_completed_at'] === null ? null : json['calibration_completed_at'],
        'lastTaredAt': json['last_tared_at'] === undefined ? undefined : json['last_tared_at'] === null ? null : json['last_tared_at'],
        'expectedFractions': json['expected_fractions'] === undefined ? undefined : json['expected_fractions'] === null ? null : json['expected_fractions'],
        'signs': json['signs'] === undefined ? undefined : json['signs'] === null ? null : json['signs'],
    };
}

export function CalibrationToJSON(json: any): Calibration {
    return CalibrationToJSONTyped(json, false);
}

export function CalibrationToJSONTyped(value?: Calibration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'calibrations': ((value['calibrations'] as Array<any>).map(CalibrationItemToJSON)),
        'tare': value['tare'],
        'calibration_type': value['calibrationType'],
        'calibration_completed_at': value['calibrationCompletedAt'],
        'last_tared_at': value['lastTaredAt'],
        'expected_fractions': value['expectedFractions'],
        'signs': value['signs'],
    };
}

